import React from 'react';
import { Button, Icon, IconButton, Tooltip } from '@mui/material';
import { OEM_DATA_ICON } from './constants';
import { useOemDataAction } from './hooks/useOemDataAction';

// Clicks inside the action (and inside the portal'd modal, which bubble through
// the React tree) must not reach the row/card/bubble that hosts it.
const stop = (event) => event.stopPropagation();

const Trigger = ({ variant, iconSize, disabled, label, onClick }) => {
	if (variant === 'button') {
		return (
			<Button
				variant="outlined"
				size="small"
				startIcon={<Icon fontSize="small">{OEM_DATA_ICON}</Icon>}
				disabled={disabled}
				onClick={onClick}
			>
				{label}
			</Button>
		);
	}
	return (
		// 'medium' (24px) takes the row's text color, matching neighbouring icons
		// such as the Units list's gps_fixed; 'small' keeps MUI's default muted color.
		<IconButton
			size="small"
			color={iconSize === 'medium' ? 'inherit' : 'default'}
			aria-label={label}
			disabled={disabled}
			onClick={onClick}
		>
			<Icon fontSize={iconSize}>{OEM_DATA_ICON}</Icon>
		</IconButton>
	);
};

/**
 * Entry point to the OEM data modal for one reading, as a button or an icon
 * (see `useOemDataAction` for visibility, the disabled state and the click
 * snapshot). `iconSize` ('small' | 'medium') only applies to the icon variant,
 * so each host can match its neighbouring icons.
 */
export const OemDataButton = ({ unitId, eventId, manufacturerName, unitLabel, variant = 'icon', iconSize = 'small' }) => {
	const action = useOemDataAction({ unitId, eventId, manufacturerName, unitLabel });
	if (!action.visible) return null;

	return (
		<span className="oem-data-button" onClick={stop} onMouseDown={stop}>
			<Tooltip title={action.tooltip}>
				<span>
					<Trigger
						variant={variant}
						iconSize={iconSize}
						disabled={action.disabled}
						label={action.label}
						onClick={action.open}
					/>
				</span>
			</Tooltip>
			{action.modal}
		</span>
	);
};
